// src/App.js
import React from "react";
import "./App.css";
import AppRouter from "./router/AppRouter";
import "./index.css";

function App() {
  return <AppRouter />;
}

export default App;
